import { apiClient } from './client';

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: 'super_admin' | 'admin' | 'viewer';
  is_active: boolean;
  created_at: string;
  last_login_at: string | null;
}

export interface Pagination {
  total: number;
  limit: number;
  offset: number;
  has_more: boolean;
}

export interface AdminUserListResponse {
  users: AdminUser[];
  pagination: Pagination;
}

export interface AdminUserUpdateRequest {
  role?: string;
  is_active?: boolean;
}

export interface AdminUserCreateRequest {
  email: string;
  password: string;
  name?: string;
  role?: string;
}

export const adminUsersApi = {
  create: async (data: AdminUserCreateRequest): Promise<AdminUser> => {
    const response = await apiClient.post<AdminUser>('/admin-users', data);
    return response.data;
  },

  list: async (limit = 50, offset = 0): Promise<AdminUserListResponse> => {
    const response = await apiClient.get<AdminUserListResponse>('/admin-users', {
      params: { limit, offset },
    });
    return response.data;
  },

  update: async (userId: string, data: AdminUserUpdateRequest): Promise<AdminUser> => {
    const response = await apiClient.patch<AdminUser>(`/admin-users/${userId}`, data);
    return response.data;
  },

  delete: async (userId: string): Promise<void> => {
    await apiClient.delete(`/admin-users/${userId}`);
  },

  resetPassword: async (userId: string, newPassword: string): Promise<void> => {
    await apiClient.post(`/admin-users/${userId}/reset-password`, {
      new_password: newPassword,
    });
  },
};
